import buildSupplierJourneyUrl from './buildSupplierJourneyUrl'
import iconByStatus from './iconByStatus'
import label from './label'
import mountTabsWithQuestionnaires from './mountTabsWithQuestionnaires'
import statusChipColor from './statusChipColor'
import statusLogTitle from './statusLogTitle'
import advisorContent from './advisorContent'
import documentSend from './documentSend'

export default {
  buildSupplierJourneyUrl,
  iconByStatus,
  label,
  mountTabsWithQuestionnaires,
  statusChipColor,
  statusLogTitle,
  advisorContent,
  documentSend,
}
